'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'sword';
var width = 576;
var height = 512;
var aliases = [128481];
var unicode = 'f71c';
var svgPathData = ['M168 280l96 96 296-296 0-96-96 0-296 296z', 'M32 416l-32 32 96 96 32-32 0-48 48-48 112 48 32-32-208-208-32 32 48 112-48 48-48 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSword = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;